import React, { useEffect, useState } from "react";
import { Card, Table, Tooltip } from "antd";
import ReportsFilter from "./ReportsFilter";
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import useApiData from "components/common/useGetApiData";
import { getAdvanceSalary } from "hooks/api/reportsApi.js";
import { ADAVANCE_SALARY } from "constants";
import { EmployeeDetails } from "components/common/CommonComponent";
import dayjs from "dayjs";
import { disabledFutureDate, formatTime12Hour, formatTimeSpan } from 'components/common/validation';
import moment from "moment";

const initialData = {
    adv_from_date: new Date(),
    adv_to_date: new Date(),
    advance_designation: "",
    advance_department: "",
    advance_employee: ""
}

function DayWiseAttendance() {
    const authtoken = sessionStorage.getItem("token");
    const pageSize = 10;
    const dateFormat = "YYYY-MM-DD";

    const [searchText, setSearchText] = useState("");
    const [dataUpdated, setDataUpdated] = useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [sorting, setSorting] = useState("");
    const [filterVisible, setFilterVisible] = useState(false);
    const [filterDatas, setFilterDatas] = useState({ ...initialData });
    const [reorderedColumns, setReorderedColumns] = useState([]);
    const tableContainerHeight = "72vh";
    const [dates, setDates] = useState({
        attendance_correction_from_date: dayjs(),
        attendance_correction_to_date: dayjs(),
    })
    const parsedFromDate = dates?.attendance_correction_from_date ? dayjs(dates?.attendance_correction_from_date) : null;
    const parsedToDate = dates?.attendance_correction_to_date ? dayjs(dates?.attendance_correction_to_date) : null;
    const [query, setQuery] = useState(`from_date=${parsedFromDate ? parsedFromDate.format(dateFormat) : ""}&to_date=${parsedToDate ? parsedToDate.format(dateFormat) : ""}&designation=${filterDatas.advance_designation ? filterDatas.advance_designation : ""}&department=${filterDatas.advance_department ? filterDatas.advance_department : ""}&employee=${filterDatas.advance_employee ? filterDatas.advance_employee : ""}`);

    useEffect(() => {
        if (!authtoken) {
            window.location.href = "/";
        }
    }, [authtoken]);

    const [data, pageInfo, loading, _message, refetch] = useApiData(getAdvanceSalary, {
        pageNo,
        pageSize,
        query,
        searchText,
        sorting,
    });

    useEffect(() => {
        if (_message && _message.isErrorMsg && _message.errorMsgText) {
            ToastMsg('error', _message.errorMsgText);
        }
    }, [_message.errorMsgText]);

    useEffect(() => {
        const parsedFromDate = dates.attendance_correction_from_date ? dayjs(dates.attendance_correction_from_date) : null;
        const parsedToDate = dates.attendance_correction_to_date ? dayjs(dates.attendance_correction_to_date) : null;
        const newQuery = `from_date=${parsedFromDate ? parsedFromDate.format(dateFormat) : ""}&to_date=${parsedToDate ? parsedToDate.format(dateFormat) : ""}&designation=${filterDatas.advance_designation ? filterDatas.advance_designation : ""}&department=${filterDatas.advance_department ? filterDatas.advance_department : ""}&employee=${filterDatas.advance_employee ? filterDatas.advance_employee : ""}`;
        setQuery(newQuery);
    }, [filterDatas, dates]);

    // filter start
    const renderFilter = (data) => {
        setFilterDatas((prevdata) => ({ ...prevdata, ...data }));
        setPageNo(1);
        // refetch(1,
        //   pageSize,
        //   `date=${data.day_wise_date ? dayjs(data.day_wise_date).format(dateFormat) : ""}&designation=${data.day_wise_designation ? data.day_wise_designation : ""}&department=${data.day_wise_department ? data.day_wise_department : ""}&employee_group=${data.day_wise_employee_grp ? data.day_wise_employee_grp : ""}`,
        //   searchText,
        //   sorting);
        setFilterVisible(false);
    }

    const ClosePopUp = () => {
        setFilterVisible(false);
    }

    const clearFilter = () => {
        setFilterDatas({ ...initialData });
        setPageNo(1);
        // refetch(1,
        //   pageSize,
        //   query,
        //   searchText,
        //   sorting);
    }
    //filter end

    const handleSearch = () => {
        setPageNo(1);
        refetch(1,
            pageSize,
            query,
            searchText,
            sorting);
        setDataUpdated(!dataUpdated);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        const sortorder = `sort=${sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : ""}&`
        const sortQuery = sorter.order ? `${sortorder}column=${sorter.columnKey}` : "";
        refetch(pagination.current,
            pageSize,
            query,
            searchText,
            sortQuery);
        setSorting(sortQuery)
    }

    const columns = [
        {
            title: "Employee",
            dataIndex: "employee__employee_name",
            key: "employee__employee_name",
            width: "20%",
            sorter: true,
            fixed: 'left',
            render: (_, record) => {
                let empDetails = {
                    ...record.employee,
                    "designation_id": record?.employee?.designation ? { id: record?.employee?.designation.id, designation_name: record?.employee?.designation.name } : { id: 0, designation_name: "" },
                    "first_name": record?.employee?.employee_name ? record?.employee?.employee_name : "",
                    "id": record?.employee?.employee_id
                }
                return <EmployeeDetails details={empDetails} />;
            }
        },
        {
            title: "Request Date",
            dataIndex: "request_date",
            key: "request_date",
            sorter: true,
            width: "8dw",
            render: (_, record) => {
                return (<p>{record.request_date ? moment(record?.request_date, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY") : "-"}</p>)
            }
        },
        {
            title: "Requested Amount",
            key: "advance_requested",
            dataIndex: "advance_requested",
            sorter: true,
            width: "12dvw",
            align: "right",
            render: (_, record) => (<span >{record.advance_requested ? (record.advance_requested) : "-"}</span>),
        },
        {
            title: "EMI Period",
            key: "emi_period",
            dataIndex: "emi_period",
            sorter: true,
            width: "8dvw",
            align: "center",
            render: (_, record) => (
                <p style={{ color: "black" }}>{record?.emi_period ? record?.emi_period : "-"}</p>),
        },
        {
            title: "Approved Amount",
            key: "advance_approved",
            dataIndex: "advance_approved",
            sorter: true,
            width: "12dvw",
            align: "right",
            render: (_, record) => (<span>{record.advance_approved ? (record.advance_approved) : "-"}</span>),
        },
        {
            title: "Approved Date",
            dataIndex: "approval_date",
            key: "approval_date",
            sorter: true,
            render: (_, record) => {
                return (<p>{record.approval_date ? moment(record?.approval_date, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY") : "-"}</p>)
            }
        },
        {
            title: "Approved By",
            dataIndex: "approved_by",
            key: "approved_by",
            sorter: true,
            render: (_, record) => {
                let colors = "black"
                return (record.approved_by?.length > 20 ?
                    <Tooltip title={record.approved_by}>{<span style={{ color: colors }}>{record.approved_by?.slice(0, 20) + "..."}</span>}</Tooltip>
                    : <p style={{ color: colors }}>{record.approved_by ? record.approved_by : "-"}</p>)
            },
            align: 'left',
        },
    ];

    const handleFilter = () => {
        setFilterVisible(true)
    }

    const handleStateChanges = (search = "", reorderedList = []) => {
        setSearchText(search)
        setReorderedColumns(reorderedList)
    }

    const queryString =
        "?page_no=" + pageNo +
        "&page_size=" + pageSize +
        "&from_date=" + (parsedFromDate ? parsedFromDate.format(dateFormat) : null) +
        "&to_date=" + (parsedToDate ? parsedToDate.format(dateFormat) : null) +
        "&designation=" + (filterDatas.advance_designation ? filterDatas.advance_designation : "") +
        "&department=" + (filterDatas.advance_department !== undefined ? filterDatas.advance_department : "") +
        "&employee=" + (filterDatas.advance_employee !== undefined ? filterDatas.advance_employee : "") +
        "&search=" + searchText + (sorting ? `&${sorting}` : "");

    const styles = {
        fltContainer: {
            border: "1px solid #cbcbcb",
            height: tableContainerHeight,
        },
    }

    // Date changes start - Filter the data based on the selected date
    const handleFromDateChange = (date) => {
        setDates((prevState) => ({
            ...prevState,
            attendance_correction_from_date: date,
        }));
    };

    const disabledDateFrom = (restrictionDate) => (current) => {
        if (restrictionDate) {
            const startDate = dayjs(restrictionDate, 'DD-MM-YYYY');
            return current && current < startDate.startOf('day');
        }
        return current && current > dayjs().endOf('day');
    };

    const handleToDateChange = (value) => {
        setDates((prevState) => ({
            ...prevState,
            attendance_correction_to_date: value,
        }));
    }
    // Date changes end

    return (
        <Card className="h-full overflow-hidden">
            <div className={"h-1/6"}>
                <CommonTblHeader pageName={"Advance Salary Report"}
                    pageInfo={pageInfo} handleSearch={handleSearch}
                    onStateChange={handleStateChanges} handleFilter={handleFilter} columns={columns}
                    url={ADAVANCE_SALARY} query={queryString}
                    isAddRequired={false} isDraftRequired={false}
                    isDateRequired={true} handleDateChange={handleFromDateChange}
                    selectedDate={dates.attendance_correction_from_date} isToDateRequired={true}
                    handleToDateChange={handleToDateChange} selectedToDate={dates.attendance_correction_to_date}
                    fromDateTlt={"Select From Date"} toDateTlt={"Select To Date"}
                    disabledFromDate={disabledFutureDate}
                    disabledToDate={disabledDateFrom(dates.attendance_correction_from_date)}
                />
            </div>
            <div className="relative h-5/6 mt-1">
                {filterVisible ?
                    <div className="absolute w-1/4 z-10" style={{ ...styles.fltContainer, background: "white" }}>
                        <ReportsFilter
                            pageName={"Advance Salary Report"}
                            filterDatas={filterDatas}
                            closeFilter={ClosePopUp}
                            filteredData={renderFilter}
                            clearData={clearFilter} />
                    </div>
                    : null}
                <div className={"mt-5 w-full"} style={styles.fltContainer}>
                    <Table
                        columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
                        dataSource={data?.length > 0 ? data : null}
                        loading={loading}
                        style={{ "--table-container-height": tableContainerHeight }}
                        scroll={{ y: `calc(${tableContainerHeight} - 110px)`, }}
                        onChange={handleTableChange}
                        pagination={{
                            style: { marginRight: 20, padding: 0 },
                            defaultPageSize: pageSize,
                            showSizeChanger: false,
                            showQuickJumper: true,
                            total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
                            pageSizeOptions: ["10", "20", "30"],
                            pageSize,
                            defaultCurrent: pageNo,
                        }}
                        key={dataUpdated ? "updated" : "not-updated"}
                    />
                </div>
            </div>
        </Card>
    );
}

export default DayWiseAttendance;
